// One rule for every form that takes a postal code. Customers are not only in
// the US: 12345, 12345-6789, SW1A 1AA (UK), K1A 0B1 (Canada), 400001 (India).
// 3 to 10 characters of letters, digits, spaces and hyphens, starting and
// ending with a letter or digit. The DB column is varchar(32).
export const POSTAL_CODE_RE = /^[A-Za-z0-9][A-Za-z0-9 -]{1,8}[A-Za-z0-9]$/
export const POSTAL_CODE_MESSAGE =
  'Enter a valid postal code: 3 to 10 letters, digits, spaces or hyphens.'
